import'string.prototype.startswith';
import {
    ARTICLE_FORM_ATTACHMENT_REMOVE, ARTICLE_FORM_ATTACHMENTS_CHANGE, CHANGE_ARTICLE_FORM_INFO_STATE,
    CHANGE_ARTICLE_FORM_SETTINGS,
    FAILED_TO_POST_NEW_ARTICLE,
    LOGOUT, RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE, RECEIVE_PATCH_ARTICLE, RECEIVE_POST_NEW_ARTICLE,
    RECEIVE_SPECIFIC_ARTICLE, REQUEST_PATCH_ARTICLE,
    REQUEST_POST_NEW_ARTICLE
} from "../actions/index";

const defaultState = {
    title: '',
    body: '',
    attachments: [],
    articleBody: '',
    editorState: '',
    live: false,
    errorMsg: '',
    posting: false,
    postSuccessMsg:'',
    infoState: {
        body: false,
        upload: false,
        live: false
    },
    id: -1,
    patching: false,
    fetchedArticleAttachments: []
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case REQUEST_PATCH_ARTICLE:
            return {
                ...state,
                patching: true
            };
        case RECEIVE_PATCH_ARTICLE:
            return {
                ...state,
                patching: false,
                postSuccessMsg: 'Article was changed successfully.'
            };
        case RECEIVE_FAILED_RESPONSE_PATCH_ARTICLE:
            return {
                ...state,
                patching: false,
                errorMsg:action.payload
            };
        case RECEIVE_SPECIFIC_ARTICLE:
            return {
                ...state,
                fetchedArticleAttachments: action.payload.attatchmentDtos,
                title: action.payload.title,
                live: action.payload.live,
                editorState: '',
                articleBody: action.payload.body,
                id: action.payload.id
            };
        case CHANGE_ARTICLE_FORM_INFO_STATE:
            return {
                ...state,
                infoState: {
                    ...state.infoState,
                    [action.payload.key]: !state.infoState[action.payload.key]
                }
            };
        case REQUEST_POST_NEW_ARTICLE:
            return {
                ...state,
                posting:true,
                errorMsg: ''
            };
        case RECEIVE_POST_NEW_ARTICLE:
            return {
                ...defaultState,
                postSuccessMsg: 'Article was created successfully.'
            };
        case FAILED_TO_POST_NEW_ARTICLE:
            return {
                ...state,
                posting: false,
                errorMsg:action.payload
            };
        case ARTICLE_FORM_ATTACHMENTS_CHANGE:
            return {
                ...state,
                attachments: [...state.attachments, action.payload]
            };
        case ARTICLE_FORM_ATTACHMENT_REMOVE:
            let newAttachments = [...state.attachments];
            if (action.payload > -1) {
                newAttachments.splice(action.payload, 1);
            }
            return {
                ...state,
                attachments: newAttachments
            };
        case CHANGE_ARTICLE_FORM_SETTINGS:
            return {
                ...state,
                [action.payload.key]: action.payload.value,
                errorMsg: action.payload.key==='errorMsg'?action.payload.value:'',
                postSuccessMsg: ''
            };
        case LOGOUT:
            return {
                ...defaultState
            };
        case '@@router/LOCATION_CHANGE':
            return {
                ...defaultState
            };
        default :
            return state
    }
}